export const pcPageConfig = {
  "title": "Revenue",
  "titleCN": "付费流水",
  "path": "/monetization/inGameRevenue",
  "defaultTab": "revenue",
  "tabList": [
    {
      "id": "revenue",
      "tabName": "MTX Revenue",
      "tabNameCN": "MTX 收入",
      "isHaveNotification": true,
      "refresh": false,
      "notificationPath": "/monetization/inGameRevenue/revenue",
      "path": "/monetization/inGameRevenue/revenue",
      "tabIcon": "",
      "logConfig": {
        "pageId": "205501",
        "pageName": "monetizationInGameRevenueRevenue",
        "extInfo": "monetizationInGameRevenueRevenue",
        "pagePath": "/monetization/inGameRevenue/revenue"
      },
      "filters": [
        {
          "name": "IngameRevenueFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/monetization/inGameRevenue/revenue",
          "componentList": [
            {
              "name": "PlatformMetricsCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/monetization/revenue/mtx_revenue/card_metrics",
                  "metricsList": [
                    "platform_mtx_revenue"
                  ],
                  "isConfirm": true,
                  "dateFilterIsRange": true
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 24
                      },
                      "children": [
                        {
                          "name": "PlatformCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "platform_mtx_revenue",
                                  "enName": "MTX Revenue",
                                  "cnName": "MTX 收入",
                                  "rangeEnName": "MTX Revenue",
                                  "rangeCnName": "MTX 收入",
                                  "endEnName": "",
                                  "endCnName": "",
                                  "preUnit": "$",
                                  "endUnit": "",
                                  "rainbowKey": "Pc MTX Revenue",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "money",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "IngameDlpBreakdownService",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/monetization/revenue/mtx_revenue/multi_metrics_breakdown",
                  "metric": [
                    "platform_net_units_sold",
                    "platform_mtx_revenue"
                  ],
                  "byType": "by_product",
                  "topMetric": "platform_net_units_sold",
                  "extMetricMap": {
                    "platform_net_units_sold": "platform_mtx_revenue",
                    "platform_mtx_revenue": "platform_net_units_sold"
                  }
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "dbd-saleOverview-row dbd-saleOverview-breakdown-row",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "dbd-ingame-revenue-breakdown",
                      "type": "layout",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "IngameDlpTopChartContext",
                          "props": {
                            "config": {
                              "top10TitleEn": "DLP Top-up Breakdown",
                              "top10TitleCn": "DLP充值细分",
                              "titleNameEn": "DLP",
                              "titleNameCn": "DLP",
                              "defaultSortMetric": "platform_net_units_sold",
                              "chart": [
                                {
                                  "metric": "platform_net_units_sold",
                                  "name": "Units",
                                  "nameCn": "销量",
                                  "format": "thousandsInit",
                                  "percentFormat": "percent1Decimal"
                                },
                                {
                                  "metric": "platform_mtx_revenue",
                                  "name": "MTX Revenue($)",
                                  "nameCn": "MTX 收入($)",
                                  "format": "thousands2Decimal",
                                  "percentFormat": "percent1Decimal"
                                }
                              ],
                              "download": [
                                {
                                  "key": "full_name",
                                  "header": "HEADER"
                                },
                                {
                                  "key": "platform_net_units_sold",
                                  "header": "Units",
                                  "headerCn": "销量"
                                },
                                {
                                  "key": "platform_net_units_sold_percentage",
                                  "header": "Share of All (Units)",
                                  "headerCn": "全局占比(销量)"
                                },
                                {
                                  "key": "platform_mtx_revenue",
                                  "header": "MTX Revenue($)",
                                  "headerCn": "MTX 收入($)"
                                },
                                {
                                  "key": "platform_mtx_revenue_percentage",
                                  "header": "Share of All (MTX Revenue)",
                                  "headerCn": "全局占比(MTX 收入)"
                                }
                              ],
                              "isBasicSelector": true
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "RankListTabCo",
              "className": "",
              "style": {
                "position": "relative",
                "left": "-10px"
              },
              "type": "view",
              "isDl2": true,
              "data": {
                "regionDataType": "platform_mtx_revenue",
                "tabOrder": [
                  "platform_mtx_revenue",
                  "platform_mtx_arpu",
                  "platform_mtx_arppu",
                  "mtx_payers",
                  "mtx_payer_rate"
                ]
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 24
                  },
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 24
                      },
                      "children": [
                        {
                          "name": "PcConsoleMonetizationRevenueTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/monetization/revenue/mtx_revenue/breakdown",
                              "isSegmentFilter": true,
                              "dataKey": "MonetizationBreakdownRankData",
                              "breakDownType": "os"
                            }
                          },
                          "children": [
                            {
                              "name": "PcInGameBreakdownCo",
                              "className": "",
                              "type": "view",
                              "style": {},
                              "props": {
                                "config": {
                                  "config": {},
                                  "defaultActive": 0,
                                  "isHaveBar": true,
                                  "isHaveLine": true,
                                  "isHavePie": true,
                                  "isHaveShare": true,
                                  "shareMetrics": [
                                    "platform_mtx_revenue",
                                    "mtx_payers"
                                  ]
                                }
                              },
                              "children": []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 24
                      },
                      "children": [
                        {
                          "name": "PcConsoleMonetizationRevenueTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/monetization/revenue/mtx_revenue/breakdown",
                              "isSegmentFilter": true,
                              "dataKey": "MonetizationBreakdownRankData",
                              "breakDownType": "country",
                              "beforeRequest": "function(data, params) {\n                                var metric = data.regionDataType || params.metric;\n                                var sortMetrics = ['platform_mtx_arpu', 'platform_mtx_arppu', 'mtx_arpu', 'mtx_arppu', 'mtx_payers', 'mtx_payer_rate'];\n                                if (sortMetrics.indexOf(metric) === -1) {\n                                  return params;\n                                }\n                                return Object.assign({}, params, {\n                                  multi_sort: [{\n                                    sort_by: 'platform_mtx_revenue',\n                                    desc: true\n                                  }]\n                                });\n                              }"
                            }
                          },
                          "children": [
                            {
                              "name": "PcInGameBreakdownCo",
                              "type": "view",
                              "props": {
                                "config": {
                                  "config": {},
                                  "defaultActive": 0,
                                  "isHaveBar": true,
                                  "isHaveLine": true,
                                  "isHavePie": true,
                                  "isHaveShare": true,
                                  "shareMetrics": [
                                    "platform_mtx_revenue",
                                    "mtx_payers"
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "IngamePayerOrArpuService",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/monetization/revenue/mtx_revenue/metrics_trend",
                  "dataKey": "PcMonetizationRevenueData",
                  "metrics": [
                    "mtx_payer_rate",
                    "mtx_payers",
                    "platform_mtx_arpu",
                    "platform_mtx_arppu"
                  ],
                  "payerResKey": [
                    "mtx_payer_rate",
                    "mtx_payers"
                  ],
                  "arpuResKey": [
                    "platform_mtx_arpu",
                    "platform_mtx_arppu"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "margin-b-10 margin-t-10",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PcPayerAndPayerCo",
                          "className": "",
                          "style": {},
                          "enName": "Payer & Pay Rate - In-Game Store",
                          "cnName": "付费人数和付费渗透率-游戏内商店",
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetricsConfig": [
                                {
                                  "metricKey": "mtx_payers",
                                  "enName": "Payer",
                                  "cnName": "付费人数",
                                  "isPercent": false,
                                  "decimal": 0,
                                  "type": "int"
                                },
                                {
                                  "metricKey": "mtx_payer_rate",
                                  "enName": "Pay Rate",
                                  "cnName": "付费渗透率",
                                  "isPercent": true,
                                  "decimal": 2,
                                  "type": "percent"
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PcRevenueMetricsTrendsCo",
                          "className": "",
                          "enName": "ARPU & ARPPU - In-Game Store",
                          "cnName": "ARPU & 付费ARPPU-游戏内商店",
                          "defaultActive": 2,
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "chart": {
                                "type": "decimals",
                                "isPercent": false,
                                "decimal": 2
                              },
                              "componentMetricsConfig": [
                                {
                                  "metricKey": "platform_mtx_arpu",
                                  "enName": "ARPU($)",
                                  "cnName": "ARPU($)",
                                  "isPercent": false,
                                  "decimal": 2,
                                  "type": "decimals"
                                },
                                {
                                  "metricKey": "platform_mtx_arppu",
                                  "enName": "ARPPU($)",
                                  "cnName": "ARPPU($)",
                                  "isPercent": false,
                                  "decimal": 2,
                                  "type": "decimals"
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverviewTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "tableConfig": {
                    "title": "monetization_revenue_Overall_Payment"
                  },
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/monetization/revenue/mtx_revenue/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/monetization/revenue/mtx_revenue/overall_performance/download"
                  },
                  "componentMetricsConfig": {
                    "Day": [
                      {
                        "metricKey": "lifetime_platform_mtx_revenue",
                        "reqMetricKey": "lifetime_platform_mtx_revenue",
                        "enPercentWidth": 220,
                        "cnPercentWidth": 200,
                        "enWidth": 260,
                        "cnWidth": 180,
                        "enName": "Lifetime MTX Revenue($)",
                        "cnName": "累计 MTX 收入($)",
                        "rainbowKey": "Pc Lifetime MTX Revenue",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "platform_mtx_revenue",
                        "reqMetricKey": "platform_mtx_revenue",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 160,
                        "enWidth": 200,
                        "cnWidth": 140,
                        "enName": "MTX Revenue($)",
                        "cnName": "MTX 收入($)",
                        "rainbowKey": "Pc MTX Revenue",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "active_users",
                        "reqMetricKey": "active_users",
                        "enPercentWidth": 140,
                        "cnPercentWidth": 120,
                        "enWidth": 140,
                        "cnWidth": 100,
                        "enName": "DAU",
                        "cnName": "日活跃",
                        "rainbowKey": "Pc DAU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "platform_mtx_arpu",
                        "reqMetricKey": "platform_mtx_arpu",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 180,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "ARPU",
                        "cnName": "ARPU",
                        "rainbowKey": "Pc ARPU",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "platform_mtx_arppu",
                        "reqMetricKey": "platform_mtx_arppu",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "ARPPU",
                        "cnName": "ARPPU",
                        "rainbowKey": "Pc ARPPU",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_payers",
                        "reqMetricKey": "mtx_payers",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "Payer",
                        "cnName": "付费人数",
                        "rainbowKey": "Pc Payer",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_payer_rate",
                        "reqMetricKey": "mtx_payer_rate",
                        "enPercentWidth": 200,
                        "cnPercentWidth": 200,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "Pay Rate",
                        "cnName": "付费渗透率",
                        "rainbowKey": "Pc Pay Rate",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      }
                    ],
                    "Week": [
                      {
                        "metricKey": "lifetime_platform_mtx_revenue",
                        "reqMetricKey": "lifetime_platform_mtx_revenue",
                        "enPercentWidth": 220,
                        "cnPercentWidth": 200,
                        "enWidth": 260,
                        "cnWidth": 180,
                        "enName": "Lifetime MTX Revenue($)",
                        "cnName": "累计 MTX 收入($)",
                        "rainbowKey": "Pc Lifetime MTX Revenue",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "platform_mtx_revenue",
                        "reqMetricKey": "platform_mtx_revenue",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 160,
                        "enWidth": 200,
                        "cnWidth": 140,
                        "enName": "MTX Revenue($)",
                        "cnName": "MTX 收入($)",
                        "rainbowKey": "Pc MTX Revenue",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "active_users",
                        "reqMetricKey": "active_users",
                        "enPercentWidth": 140,
                        "cnPercentWidth": 120,
                        "enWidth": 140,
                        "cnWidth": 100,
                        "enName": "WAU",
                        "cnName": "周活跃",
                        "rainbowKey": "Pc WAU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "platform_mtx_arpu",
                        "reqMetricKey": "platform_mtx_arpu",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 180,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "ARPU",
                        "cnName": "ARPU",
                        "rainbowKey": "Pc ARPU",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "platform_mtx_arppu",
                        "reqMetricKey": "platform_mtx_arppu",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "ARPPU",
                        "cnName": "ARPPU",
                        "rainbowKey": "Pc ARPPU",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_payers",
                        "reqMetricKey": "mtx_payers",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "Payer",
                        "cnName": "付费人数",
                        "rainbowKey": "Pc Payer",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_payer_rate",
                        "reqMetricKey": "mtx_payer_rate",
                        "enPercentWidth": 200,
                        "cnPercentWidth": 200,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "Pay Rate",
                        "cnName": "付费渗透率",
                        "rainbowKey": "Pc Pay Rate",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      }
                    ],
                    "Month": [
                      {
                        "metricKey": "lifetime_platform_mtx_revenue",
                        "reqMetricKey": "lifetime_platform_mtx_revenue",
                        "enPercentWidth": 220,
                        "cnPercentWidth": 200,
                        "enWidth": 260,
                        "cnWidth": 180,
                        "enName": "Lifetime MTX Revenue($)",
                        "cnName": "累计 MTX 收入($)",
                        "rainbowKey": "Pc Lifetime MTX Revenue",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "platform_mtx_revenue",
                        "reqMetricKey": "platform_mtx_revenue",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 160,
                        "enWidth": 200,
                        "cnWidth": 140,
                        "enName": "MTX Revenue($)",
                        "cnName": "MTX 收入($)",
                        "rainbowKey": "Pc MTX Revenue",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "active_users",
                        "reqMetricKey": "active_users",
                        "enPercentWidth": 140,
                        "cnPercentWidth": 120,
                        "enWidth": 140,
                        "cnWidth": 100,
                        "enName": "MAU",
                        "cnName": "月活跃",
                        "rainbowKey": "Pc MAU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "platform_mtx_arpu",
                        "reqMetricKey": "platform_mtx_arpu",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 180,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "ARPU",
                        "cnName": "ARPU",
                        "rainbowKey": "Pc ARPU",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "platform_mtx_arppu",
                        "reqMetricKey": "platform_mtx_arppu",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "ARPPU",
                        "cnName": "ARPPU",
                        "rainbowKey": "Pc ARPPU",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_payers",
                        "reqMetricKey": "mtx_payers",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "Payer",
                        "cnName": "付费人数",
                        "rainbowKey": "Pc Payer",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_payer_rate",
                        "reqMetricKey": "mtx_payer_rate",
                        "enPercentWidth": 200,
                        "cnPercentWidth": 200,
                        "enWidth": 150,
                        "cnWidth": 150,
                        "enName": "Pay Rate",
                        "cnName": "付费渗透率",
                        "rainbowKey": "Pc Pay Rate",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      }
                    ]
                  }
                }
              }
            }
          ]
        }
      ]
    },
    {
      "id": "system",
      "tabName": "Economy System",
      "tabNameCN": "经济系统",
      "isHaveNotification": true,
      "refresh": false,
      "notificationPath": "/monetization/inGameRevenue/system",
      "path": "/monetization/inGameRevenue/system",
      "tabIcon": "",
      "logConfig": {
        "pageId": "205502",
        "pageName": "monetizationInGameRevenueSystem",
        "extInfo": "monetizationInGameRevenueSystem",
        "pagePath": "/monetization/inGameRevenue/system"
      },
      "filters": [
        {
          "name": "IngameRevenueFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/monetization/inGameRevenue/system",
          "componentList": [
            {
              "name": "KeyMetricsCo",
              "className": "dbd-daily-card",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "isChangeHeight": 200,
                  "dateFilterIsRange": true,
                  "api": "/api/v1/dashboard/pc/monetization/revenue/economy_system/card_metrics",
                  "mainMetricsList": [
                    "igc_dlp_earned",
                    "igc_dlp_spend",
                    "igc_dlp_balance"
                  ],
                  "metricsList": [
                    "igc_dlp_earned",
                    "igc_dlp_spend",
                    "igc_dlp_balance"
                  ],
                  "isConfirm": true
                }
              },
              "children": [
                {
                  "name": "HaveDataDateRange",
                  "className": "margin-t-20",
                  "style": {},
                  "type": "view",
                  "titleEn": "Key Metrics",
                  "titleCn": "关键指标",
                  "needTitle": true
                },
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "igc_dlp_earned",
                                  "enName": "DLP Earned",
                                  "cnName": "DLP获取",
                                  "rangeEnName": "DLP Earned",
                                  "rangeCnName": "DLP获取",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc DLP Earned",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "game",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "igc_dlp_spend",
                                  "enName": "DLP Spend",
                                  "cnName": "DLP花费",
                                  "rangeEnName": "DLP Spend",
                                  "rangeCnName": "DLP花费",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc DLP Spend",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "game",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "igc_dlp_balance",
                                  "enName": "DLP Balance to-date",
                                  "cnName": "DLP存量",
                                  "rangeEnName": "DLP Balance to-date",
                                  "rangeCnName": "DLP存量",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc DLP Balance to-date",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "game",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "IngameDlpBreakdownService",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/monetization/revenue/economy_system/multi_metrics_breakdown",
                  "metric": [
                    "item_net_units",
                    "item_dlp_usd_profix"
                  ],
                  "byType": "by_title",
                  "topMetric": "item_net_units",
                  "extMetricMap": {
                    "item_dlp_usd_profix": "item_net_units",
                    "item_net_units": "item_dlp_usd_profix"
                  },
                  "serviceParams": {
                    "top_num": 30
                  }
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "dbd-saleOverview-row dbd-saleOverview-breakdown-row",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "dbd-ingame-revenue-breakdown",
                      "type": "layout",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "IngameDlpTopChartContext",
                          "props": {
                            "config": {
                              "top10TitleEn": "Top 30 Selling Items - In-Game Store",
                              "top10TitleCn": "Top 30 热销商品-游戏内商店",
                              "titleNameEn": "Items",
                              "titleNameCn": "项目",
                              "defaultSortMetric": "item_net_units",
                              "chart": [
                                {
                                  "metric": "item_net_units",
                                  "name": "Units",
                                  "nameCn": "销量",
                                  "format": "thousandsInit",
                                  "percentFormat": "percent1Decimal"
                                },
                                {
                                  "metric": "item_dlp_usd_profix",
                                  "name": "DLP USD Profit($)",
                                  "nameCn": "DLP USD 利润($)",
                                  "format": "thousands2Decimal",
                                  "percentFormat": "percent1Decimal"
                                }
                              ],
                              "download": [
                                {
                                  "key": "full_name",
                                  "header": "HEADER"
                                },
                                {
                                  "key": "item_net_units",
                                  "header": "Units",
                                  "headerCn": "销量"
                                },
                                {
                                  "key": "item_net_units_percentage",
                                  "header": "Share of All (Units)",
                                  "headerCn": "全局占比(销量)"
                                },
                                {
                                  "key": "item_dlp_usd_profix",
                                  "header": "DLP USD Profit($)",
                                  "headerCn": "DLP USD 利润($)"
                                },
                                {
                                  "key": "item_dlp_usd_profix_percentage",
                                  "header": "Share of All (DLP USD Profit($))",
                                  "headerCn": "全局占比(DLP USD 利润($))"
                                }
                              ],
                              "isBasicSelector": true
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverviewTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/monetization/revenue/economy_system/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/monetization/revenue/economy_system/overall_performance/download"
                  },
                  "tableConfig": {
                    "title": "monetization_revenue_Overall_Payment",
                    "isShowProgressBar": false
                  },
                  "isSingleDate": false,
                  "customColumns": [
                    {
                      "columnKey": "title",
                      "valueKey": "title",
                      "rainbowKey": "Pc DLP Title",
                      "nameEn": "Title",
                      "nameCn": "名称",
                      "enWidth": 255,
                      "cnWidth": 255
                    },
                    {
                      "columnKey": "price",
                      "valueKey": "price",
                      "rainbowKey": "Pc DLP Price",
                      "nameEn": "Price($)",
                      "nameCn": "价格($)",
                      "enWidth": 120,
                      "cnWidth": 120
                    }
                  ],
                  "componentMetrics": [
                    {
                      "metricKey": "item_dlp_spend",
                      "reqMetricKey": "item_dlp_spend",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 160,
                      "enWidth": 160,
                      "cnWidth": 140,
                      "enName": "DLP Spend",
                      "cnName": "DLP花费",
                      "rainbowKey": "Pc DLP Spend",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "item_dlp_usd_profix",
                      "reqMetricKey": "item_dlp_usd_profix",
                      "enPercentWidth": 200,
                      "cnPercentWidth": 180,
                      "enWidth": 180,
                      "cnWidth": 160,
                      "enName": "DLP USD Profit($)",
                      "cnName": "DLP USD 利润($)",
                      "rainbowKey": "Pc DLP USD Profit",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "item_net_units",
                      "reqMetricKey": "item_net_units",
                      "enPercentWidth": 280,
                      "cnPercentWidth": 160,
                      "enWidth": 280,
                      "cnWidth": 140,
                      "enName": "Units",
                      "cnName": "销量",
                      "rainbowKey": "Pc Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    }
                  ],
                  "getParams": "function (params) { return Object.assign({}, params, { accumulation: Object.assign({}, params.accumulation, { by_title: true, by_price: true }) }) }"
                }
              }
            }
          ]
        }
      ]
    }
  ]
};
